import React from "react";
import { ArrowLeft } from "lucide-react";
import PageShell from "./PageShell";
import KpiBar from "./KpiBar";

/**
 * Template F — Detail (PDR §6.F)
 * ──────────────────────────────
 * Purpose : focus on a single record (Org Deep View · User Detail · Invoice Detail).
 * Slots   : backLink, header (record type + name + tagline + actions),
 *           kpis, tabs (record-specific sections), body (tab panel).
 */
export default function TemplateDetail({
  onBack, backLabel = "Back", header, kpis, tabs, body, testId = "tpl-detail",
}) {
  return (
    <PageShell testId={testId}>
      {onBack && (
        <button className="tpl-backlink" onClick={onBack} data-testid="tpl-back">
          <ArrowLeft size={13} strokeWidth={2.2} /> {backLabel}
        </button>
      )}
      {header}
      {kpis && (kpis.items ? <KpiBar items={kpis.items} cols={kpis.cols ?? 4} /> : kpis)}
      {tabs}
      {body}
    </PageShell>
  );
}
